<template>
  <v-container>
    <p v-if="loading"
       class="text-center">
      <v-progress-circular indeterminate
                           class="ml-4">
      </v-progress-circular>
    </p>
    <v-row v-if="!loading && template">
      <v-col cols="12"
             sm="8">
        <v-card>
          <v-toolbar color="primary"
                     dark
                     flat
                     tile>
            <v-toolbar-title v-if="template">
              {{ template.name }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="template">
            <div>
              Subject: {{ template.subject }}
            </div>
            <v-divider></v-divider>
          </v-card-text>
          <div v-if="dataURI"
               class="mx-4">
            <iframe :src="dataURI"
                    v-resize="onResize"
                    ref="iframe"
                    style="width: 100%; border: 1px solid #000000; margin: 0; padding: 0;"
                    :style="iframeStyle">
            </iframe>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12"
             sm="4">
        <v-card v-if="canSendCampaign"
                class="mb-4">
          <v-card-actions>
            <v-btn block
                   color="primary"
                   :to="{name: `library.mailcoach.campaign.wizard`, query: {template_id: template.id}}">
              <v-icon left>
                fal fa-paper-plane
              </v-icon>
              Send Campaign
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card>
          <v-card-actions>
            <v-btn block
                   @click.prevent="copyHTML">
              <v-icon left>
                fal fa-copy
              </v-icon>
              Copy to Clipboard
            </v-btn>
          </v-card-actions>
          <v-card-text v-if="copied">
            <p>
              Now, open your email program and paste your clipboard into the message field.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import axios from '../../services/axiosService';
import clipboardService from '../../../../ml/services/clipboardService';
import htmlService from '../../services/htmlService';

export default {
  data() {
    return {
      copied: false,
      error: null,
      loading: false,
      preview_content: null,
      template: null,
      windowSize: { // MLD-3724
        x: 0,
        y: 0,
        top: 0,
        left: 0,
      }
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    iframeStyle() {
      if (this.windowSize && this.windowSize.top) {
        const offset = this.windowSize.top + 30;
        if (offset > 30) {
          return `height: calc(100vh - ${offset}px); overflow-y: auto;`;
        }
      }
      return '';
    },
    canSendCampaign() {
      return this.user
        && this.team
        && this.team.campaigns_enabled
        && this.template.is_campaign;
    },
    dataURI() {
      if (this.preview_content) {
        return htmlService.dataURI(this.preview_content);
      }
      return null;
    },
    templateUUID() {
      return this.$route.query.template;
    },
    copyParameter() {
      if (parseInt(this.$route.query.copy)) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    onResize() { // MLD-3724
      const element = this.$refs.iframe;
      if (element) {
        const viewportOffset = element.getBoundingClientRect();
        this.windowSize = {
          x: window.innerWidth,
          y: window.innerHeight,
          //viewportOffset,
          top: viewportOffset.top,
          left: viewportOffset.left,
        }
      }
    },
    copyHTML() {
      this.copied = false;
      clipboardService.copy(this.template.html_body, true)
        .then(() => {
          this.$toast.success('Copied to clipboard');
          this.copied = true;
        })
    },
    fetchData() {
      if (this.loading) {
        return;
      }
      this.error = null;
      this.loading = true;
      axios.get(`/api/public/share-templates/${this.templateUUID}`)
        .then(response => {
          this.template = response.data;
          this.preview_content = this.template.full_html;
          if (this.copyParameter) {
            this.copyHTML();
          }
        })
        .catch(err => {
          this.error = 'We\'re sorry, but we could not find that template.';
        })
        .finally(() => {
          this.loading = false;
        })
    }
  }
}
</script>
